class ProductSizeChart extends HTMLElement {
  static get chartData() {
    return {
      "tool-size-chart": {
        "size-sm": { "hand-length": { type: "max", value: 17.5 } },
        "size-md": { "hand-length": { type: "range", value: { min: 17.5, max: 20 } } },
        "size-lg": { "hand-length": { type: "open", value: 20 } },
      },
      "glove-size-chart": {
        "size-sm": {
          "hand-length": { type: "max", value: 18 },
          "hand-circumference": { type: "range", value: { min: 19, max: 20 } }
        },
        "size-md": {
          "hand-length": { type: "range", value: { min: 18, max: 19 } },
          "hand-circumference": { type: "range", value: { min: 20, max: 22 } }
        },
        "size-lg": {
          "hand-length": { type: "range", value: { min: 19, max: 20 } },
          "hand-circumference": { type: "range", value: { min: 22, max: 23 } }
        },
        "size-xl": {
          "hand-length": { type: "range", value: { min: 20, max: 21 } },
          "hand-circumference": { type: "range", value: { min: 23, max: 24 } }
        },
        "size-xxl": {
          "hand-length": { type: "range", value: { min: 21, max: 22 } },
          "hand-circumference": { type: "range", value: { min: 24, max: 25 } }
        },
        "size-xxxl": {
          "hand-length": { type: "open", value: 22 },
          "hand-circumference": { type: "range", value: { min: 25, max: 26 } }
        },
      },
      "kids-glove-size-chart": {
        "size-sm": {
          "hand-length": { type: "closed", value: 17 },
          "hand-width": { type: "closed", value: 7 }
        },
        "size-md": {
          "hand-length": { type: "closed", value: 18.2 },
          "hand-width": { type: "closed", value: 7.5 }
        },
        "size-lg": {
          "hand-length": { type: "closed", value: 20 },
          "hand-width": { type: "closed", value: 7.9 }
        },
      }
    };
  }

  constructor() {
    super();
    this.handleUnitChange = this.handleUnitChange.bind(this);
  }

  connectedCallback() {
    this.sizeChartType = this.dataset.sizeChartType;
    
    if (!ProductSizeChart.chartData[this.sizeChartType]) {
      console.error(`Size chart type "${this.sizeChartType}" not found.`);
      return;
    }

    this.inputs = this.querySelectorAll('.size-table ul input');
    
    const checkedInput = this.querySelector('.size-table ul input:checked');
    this.currentUnit = checkedInput ? checkedInput.value : 'inches';

    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleUnitChange);
    });

    this.renderTable();
  }

  disconnectedCallback() {
    if(this.inputs) {
        this.inputs.forEach((input) => {
            input.removeEventListener('change', this.handleUnitChange);
        });
    }
  }

  handleUnitChange(e) {
    this.currentUnit = e.target.value;
    this.renderTable();
  }

  renderTable() {
    const chartData = ProductSizeChart.chartData[this.sizeChartType];

    this.querySelectorAll('.size').forEach((row) => {
      const sizeKey = row.dataset.size;
      const sizeData = chartData[sizeKey];

      if (!sizeData) return;

      const cols = row.querySelectorAll('.value');
      cols.forEach((col) => {
        const metricName = col.dataset.sizeName;
        if (sizeData[metricName]) {
          col.innerHTML = this.formatOutput(sizeData[metricName]);
        }
      });
    });

    this.querySelectorAll(`thead .symbol`).forEach((sym) => {
        sym.style.display = sym.classList.contains(this.currentUnit) ? 'inline' : 'none';
    });
  }

  formatOutput(metricData) {
    const { type, value } = metricData;
    const isInches = this.currentUnit === 'inches';
    const conversionFactor = 2.54;

    const processValue = (val) => {
      if (isInches) {
        return this.decimalToFractionHTML(val / conversionFactor);
      } else {
        return val.toFixed(1);
      }
    };

    if (type === 'range') {
      return `${processValue(value.min)} - ${processValue(value.max)}`;
    } else if (type === 'open') {
      return `${processValue(value)} +`;
    } else if (type === 'max') {
      return `&lt; ${processValue(value)}`;
    } else {
      return processValue(value);
    }
  }

  decimalToFractionHTML(number, precision = 8) {
    const whole = Math.floor(number);
    const decimal = number - whole;

    let numerator = Math.round(decimal * precision);
    let denominator = precision;

    if (numerator === 0) return `${whole}`;
    if (numerator === denominator) return `${whole + 1}`;

    const getGCD = (a, b) => (b === 0 ? a : getGCD(b, a % b));
    const common = getGCD(numerator, denominator);
    
    numerator /= common;
    denominator /= common;

    const fractionHTML = `<sup>${numerator}/${denominator}</sup>`;
    
    return whole === 0 ? fractionHTML : `${whole} ${fractionHTML}`;
  }
}

customElements.define('product-size-chart-modal', ProductSizeChart);